import { Component, ElementRef, OnDestroy, OnInit, ViewChild, inject } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter, Subscription } from 'rxjs';
import { ClientMobileHeaderComponent } from '../../shared/components/client-mobile/client-mobile-header.component';
import { ClientMobileTabbarComponent } from '../../shared/components/client-mobile/client-mobile-tabbar/client-mobile-tabbar.component';
import { FooterComponent } from '../../shared/components/footer/footer.component';
import { HeaderComponent } from '../../shared/components/header/header.component';

const MOBILE_CHROME_HIDDEN_ROUTES = new Set(['/notifications']);

@Component({
  selector: 'app-client-layout',
  standalone: true,
  imports: [
    RouterOutlet,
    HeaderComponent,
    FooterComponent,
    ClientMobileHeaderComponent,
    ClientMobileTabbarComponent,
  ],
  templateUrl: './client-layout.component.html',
  styleUrl: './client-layout.component.scss',
})
export class ClientLayoutComponent implements OnInit, OnDestroy {
  private readonly router = inject(Router);

  hideMobileChrome = false;

  @ViewChild('scrollContainer') private readonly scrollContainer?: ElementRef<HTMLElement>;

  private navSubscription?: Subscription;

  ngOnInit(): void {
    this.updateMobileChrome();
    this.navSubscription = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.updateMobileChrome();
        const el = this.scrollContainer?.nativeElement;
        if (el) {
          if (typeof el.scrollTo === 'function') {
            el.scrollTo({ top: 0, behavior: 'smooth' });
          } else {
            el.scrollTop = 0;
          }
        }
      });
  }

  ngOnDestroy(): void {
    this.navSubscription?.unsubscribe();
  }

  private updateMobileChrome(): void {
    const path = this.router.url.split('?')[0];
    this.hideMobileChrome = MOBILE_CHROME_HIDDEN_ROUTES.has(path);
  }
}
